import axios from "axios";
import { API_URL } from '../config';

class AuthService {
    generateAccessToken = (phoneNumber: string) => {
        return (axios.get(`${API_URL}/token?phoneNumber=${phoneNumber}`));
    }
}

export default AuthService;